export default "__VITE_ASSET__DlRW3CKx__"